import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid2 as Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faKaaba, faGlobeAsia, faStore, faPassport } from "@fortawesome/free-solid-svg-icons";
import { TrendingUp } from "@mui/icons-material";



const IntroContent02 = ({expanded, handleChange}) => {
    const { t } = useTranslation();
    const iconType = <FontAwesomeIcon icon={faSquarePlus} size="lg" style={{ fontSize: "40px", paddingRight: '10px', paddingLeft: '10px' }} />;

    return (
        <Container className="info-container" slotProps={{ transition: { unmountOnExit: true } }}>
            <Accordion key='panel_info_1_2' id='panel_info_1_2' sx={{ width: '100%', padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }} expanded={expanded === 'panel_info_1_2'} onChange={handleChange('panel_info_1_2')}>
                <AccordionSummary className="info-header" expandIcon={iconType} sx={{ p: 0, m: 0 }} aria-controls="panel-info-1-2-content" id="panel-info-1-2-header">
                    <Container sx={{ padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }}>
                        <Box>
                            <Box component='div' className="info-header-section2" sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }} />
                            <h1 className="info-header-title">
                                {t('bwob.task1.section2.title')} ｜ {t('bwob.task1.section2.item')}
                            </h1>
                            <p className="info-header-descript">
                                “{t('bwob.task1.section2.description')}”
                            </p>
                        </Box>
                    </Container>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, m: 0 }}>
                    <Container className="info-content">
                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section2.subject1')}</strong><br />
                        </div>

                        <Grid container alignItems="center" spacing={1} className="info-stats" sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-30" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faGlobeAsia} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w028')}</h3>
                                    <p>({t('bwob.words.w032')})</p>
                                    <h3 style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }} className="info-stat-30-bg">
                                        <div>
                                            8.9
                                            <br /><span style={{ fontSize: "14px"}}>(2020)</span>
                                        </div>
                                        <Typography variant="span" component="div" sx={{ margin: "5px", padding: "5px", }}>
                                            <TrendingUp size="lg" sx={{ fontWeight: "900", verticalAlign: "bottom", fontSize: "40px" }} /> 
                                        </Typography>
                                        <div>
                                            37.4
                                            <br /><span style={{ fontSize: "14px"}}>(2022)</span>
                                        </div>
                                    </h3>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-40" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faStore} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w029')}</h3>
                                    <p>({t('bwob.words.w032')})</p>
                                    <h3 style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }} className="info-stat-40-bg">
                                        <div>
                                            0.8
                                            <br /><span style={{ fontSize: "14px"}}>(2020)</span>
                                        </div>
                                        <Typography variant="span" component="div" sx={{ margin: "5px", padding: "5px", }}>
                                            <TrendingUp size="lg" sx={{ fontWeight: "900", verticalAlign: "bottom", fontSize: "40px" }} /> 
                                        </Typography>
                                        <div>
                                            3.2
                                            <br /><span style={{ fontSize: "14px"}}>(2022)</span>
                                        </div>
                                    </h3>
                                </div>
                            </Grid>
                        </Grid>

                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section2.subject2')}</strong><br />
                            <div style={{ width: '100%', padding: '5px 30px', fontWeight: '700' }}>
                                <FontAwesomeIcon icon={faPassport} size="lg" style={{ paddingRight: '10px' }}/>
                                {t('bwob.task1.section2.subject2-sub')}
                            </div>
                        </div>

                        <Grid container spacing={1} columns={12} sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 12, sm: 6, md: 3, }} sx={{ padding: "0px" }}>
                                <div className="line2">
                                    <div className="info-timeline-box">{t('bwob.words.w035')}</div>
                                    <div className="info-data-item">
                                        <div style={{ height: '84px', width: '100%', padding: '2px', alignItems: 'center', overflow: 'hidden' }}>
                                            <Box className="info-item-bank" />
                                        </div>
                                        <strong>{t('bwob.words.w039')} </strong>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3, }} sx={{ padding: "0px" }}>
                                <div className="line2">
                                    <div className="info-timeline-box">{t('bwob.words.w036')}</div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w040')} : </strong>
                                        <br /><span>{t('bwob.words.w051')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w041')} : </strong>
                                        <br /><span>{t('bwob.words.w052')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w042')} : </strong>
                                        <br /><span>{t('bwob.words.w053')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w043')} : </strong>
                                        <br /><span>{t('bwob.words.w054')}</span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3, }} sx={{ padding: "0px" }}>
                                <div className="line2">
                                    <div className="info-timeline-box">{t('bwob.words.w037')}</div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w044')} : </strong>
                                        <br /><span>{t('bwob.words.w055')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w045')} : </strong>
                                        <br /><span>{t('bwob.words.w056')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w046')} : </strong>
                                        <br /><span>{t('bwob.words.w057')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w047')} : </strong>
                                        <br /><span>{t('bwob.words.w058')}</span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3, }} sx={{ padding: "0px" }}>
                                <div className="line2">
                                    <div className="info-timeline-box">{t('bwob.words.w038')}</div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w048')} : </strong>
                                        <br /><span>{t('bwob.words.w059')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w049')} : </strong>
                                        <br /><span>{t('bwob.words.w060')}</span>
                                    </div>
                                    <div className="info-data-item">
                                        <strong>{t('bwob.words.w050')} : </strong>
                                        <br /><span>{t('bwob.words.w061')}</span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>

                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section2.subject3')}</strong>
                            <List sx={{ width: '100%', padding: '0px 10px' }}>
                                <ListItem alignItems="flex-start">
                                    <ListItemAvatar sx={{ paddingRight: '10px', borderRight: { sm: 'none', md: '1px solid #d0d0d0' }, display: { xs: 'none', sm:'flex', md: 'flex' } }}>
                                        <img src={`${process.env.PUBLIC_URL}/images/intro/ibm.png`} style={{ height: '40px' }} />
                                    </ListItemAvatar>
                                    <ListItemText primary={t('bwob.task1.section2.subject3-sub')} secondary= {t('bwob.task1.section2.subject3-sub-add')} sx={{ paddingLeft: '10px' }} />
                                </ListItem>
                            </List>
                        </div>

                    </Container>
                </AccordionDetails>
            </Accordion>

        </Container>
    );
};

IntroContent02.propTypes = {
    expanded: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default IntroContent02;